<template>
  <v-dialog
    v-model="dialog"
    max-width="420px"
    scrollable>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        color="primary"
        x-small
        icon
        v-on="on">
        <v-icon
          size="17">
          $paper_cog
        </v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="px-4 pb-1">
        <title-label :label="title" />
        <v-spacer />
        <v-icon
          class="dialog-close-tr"
          color="#C8C8C8"
          small
          @click="setDialog(false)">
          mdi-close
        </v-icon>
      </v-card-title>
      <v-card-text class="px-4">
        <div class="no-option--container d-flex flex-grow-1 align-center justify-center setting-subtitle">
          {{ $t('papers.builder.settings.none.placeholder') }}
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'None'
    }
  },
  data () {
    return {
      dialog: false
    }
  },
  methods: {
    setDialog (dialog = false) {
      this.dialog = dialog
    }
  }
}
</script>
<style scoped>
  .no-option--container {
    height: 300px;
  }
  .setting-subtitle {
    color: #B8B8B8;
    font-size: 16px;
  }
</style>
